module.exports = __webpack_public_path__ + "img/6.889f546d.png";